import _ from 'lodash'

import {
  CONNECT_TO_SOCKET_EVENT,
  connectToSocketEvent,
  DISCONNECT_FROM_SOCKET_EVENT,
  disconnectFromSocketEvent,
  SocketListenerPayload,
} from './actions'

interface SocketState {
  listeners: SocketListenerPayload[]
}

export const initialState = (): SocketState => ({
  listeners: [],
})

type Action = ReturnType<typeof connectToSocketEvent> | ReturnType<typeof disconnectFromSocketEvent>

export default function root(state: SocketState = initialState(), action: Action): SocketState {
  switch (action.type) {
    case CONNECT_TO_SOCKET_EVENT: {
      let { listeners } = state
      if (_.find(listeners, { eventType: action.payload.eventType }) === undefined) {
        listeners = [...listeners, action.payload]
      }
      return {
        ...state,
        listeners,
      }
    }

    case DISCONNECT_FROM_SOCKET_EVENT: {
      const index = _.findIndex(state.listeners, { eventType: action.payload.eventType })
      return {
        ...state,
        listeners: _.reject(state.listeners, (_v, i) => i === index),
      }
    }

    default:
      return state
  }
}
